import { Fragment, useEffect } from "react";
import { HeadingTitle } from "../ModalContainer";
import { useDispatch, useSelector } from "react-redux";
import { PortalNetInventoryPopupActions } from "../../../Actions/ProductionActions";
import secureLocalStorage from "react-secure-storage";
import Loading from "../../Loading/Loading";
import DataTable from "../../DataTable/DataTable";
import NoData from "../../Loading/NoData";

const PortalNetInventHeader = ["Sr. No.", "Location Name", "Qty"];

const PortalNetInvent = ({
  close,
  sync_number,
  key_id,
  activeProductListening,
}) => {
  const dispatch = useDispatch();

  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;

  const { portalNetInventPopup, loading } = useSelector(
    (state) => state.PortalNetInventoryPopup
  );

  useEffect(() => {
    dispatch(
      PortalNetInventoryPopupActions(
        "portal_net_inventory_popup",
        1,
        sync_number,
        key_id,
        activeProductListening,
        token
      )
    );
  }, [dispatch, sync_number, key_id, activeProductListening, token]);

  console.log("PORTAL NET INVENT: ", portalNetInventPopup);

  return (
    <Fragment>
      <HeadingTitle
        title={`C-External Site Code Inventory`}
        center={false}
        closeModal={close}
      />

      <div className="table-wrapper-pagination">
        <div className="table-container-pagination">
          {loading ? (
            <Loading loading={loading} color={"rgba(1, 18, 34, 1)"} size={42} />
          ) : (
            <>
              {portalNetInventPopup &&
              portalNetInventPopup?.data?.length > 0 ? (
                <DataTable
                  items_per_page={10}
                  page={1}
                  header={PortalNetInventHeader}
                  PortalNetInventPopup={
                    portalNetInventPopup && portalNetInventPopup?.data
                  }
                />
              ) : (
                <NoData title={"No Results Found"} />
              )}
            </>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default PortalNetInvent;
